import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, Observable } from 'rxjs';
import { Logger, OrganizationService } from 'src/app/@shared';
import { EventAssetsService, OfferAsset, ProductAssetsService } from 'src/app/modules/standard/v1';

const log = new Logger('OfferAssetCardsComponent');

@Component({
  selector: 'app-product-asset-cards',
  templateUrl: './product-asset-cards.component.html',
  styleUrls: ['./product-asset-cards.component.scss']
})

export class ProductAssetCardsComponent implements OnInit {

  private assetsUrl: string = '';
  viewModel$ = combineLatest([
    this.productassetService.assets$,
    this.productassetService.isLoading$,
    this.productassetService.page$,
    this.productassetService.productId$,
    this.organizationService.assetsUrl$,
    this.productassetService.totalRecords$
  ]).pipe(
    map(([assets, isLoading, page, productId, assetsUrl, totalRecords]) => {
      if (assets.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0
        page.pageIndex = 0
        this.productassetService.page(page);
        this.productassetService.reload();
        }
        this.assetsUrl = assetsUrl;
      return { assets, isLoading, page, productId, assetsUrl, totalRecords }
    }),
  );

  assetsList: OfferAsset[] = [];
  selection = new SelectionModel<OfferAsset>(true, []);

  constructor(private productassetService: ProductAssetsService<OfferAsset>,
    private organizationService: OrganizationService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private matSnackBar: MatSnackBar) { }

  ngOnInit(): void {
    log.debug('init');
    // get the product id from the parent route
    this.productassetService.productId = this.route.snapshot.params['productId'];
  }

  onSort(sortState: Sort): void {
    this.productassetService.sort(sortState);
    this.selection.clear();
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.productassetService.page(pageEvent);
  }

  onSearch(event: any) {
    this.productassetService.search(event.target.value);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }

  public clearSelection() {
    this.selection.clear();
  }

  public getImageSrc(assets: any) {
    let imagesrc = '';
    if (assets.Type === 'application/pdf') {
      imagesrc = './assets/images/pdf.png';
    } else if (assets.Type.indexOf('audio') > -1) {
      imagesrc = './assets/images/mp3.jpg';
    } else if (assets.Type.indexOf('video') > -1) {
      imagesrc = './assets/images/mp4.png';
    } else if (assets.Type.indexOf('text') > -1) {
      imagesrc = './assets/images/text.png';
    }
    else {
      imagesrc = this.assetsUrl + '/' + assets.Detail.FileName;
    }
    return imagesrc;
  }

}
